/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ n: NonNullable<unknown> }} Mk_Tut_ChapterInputs */

const en_mk_tut_chapter = /** @type {(inputs: Mk_Tut_ChapterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Chapter ${i?.n}`)
};

const id_mk_tut_chapter = /** @type {(inputs: Mk_Tut_ChapterInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Bab ${i?.n}`)
};

/**
* | output |
* | --- |
* | "Chapter {n}" |
*
* @param {Mk_Tut_ChapterInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_tut_chapter = /** @type {((inputs: Mk_Tut_ChapterInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Tut_ChapterInputs, { locale?: "en" | "id" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_tut_chapter(inputs)
	return en_mk_tut_chapter(inputs)
});